import { render, staticRenderFns } from "./ClosingBalance.vue?vue&type=template&id=1710ae59&scoped=true&"
import script from "./ClosingBalance.vue?vue&type=script&lang=js&"
export * from "./ClosingBalance.vue?vue&type=script&lang=js&"
import style0 from "./ClosingBalance.vue?vue&type=style&index=0&id=1710ae59&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1710ae59",
  null
  
)

export default component.exports